/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPNetvisorIntegrationSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ERPNetvisorIntegrationSettings model module.
   * @module model/ERPNetvisorIntegrationSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ERPNetvisorIntegrationSettings</code>.
   * @alias module:model/ERPNetvisorIntegrationSettings
   * @class
   */
  var exports = function() {
    var _this = this;




















  };

  /**
   * Constructs a <code>ERPNetvisorIntegrationSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ERPNetvisorIntegrationSettings} obj Optional instance to populate.
   * @return {module:model/ERPNetvisorIntegrationSettings} The populated <code>ERPNetvisorIntegrationSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('OrganisationIdentifier')) {
        obj['OrganisationIdentifier'] = ApiClient.convertToType(data['OrganisationIdentifier'], 'String');
      }
      if (data.hasOwnProperty('CreatedByUserID')) {
        obj['CreatedByUserID'] = ApiClient.convertToType(data['CreatedByUserID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyLegalEntityID')) {
        obj['CompanyLegalEntityID'] = ApiClient.convertToType(data['CompanyLegalEntityID'], 'Integer');
      }
      if (data.hasOwnProperty('IntegrationKey')) {
        obj['IntegrationKey'] = ApiClient.convertToType(data['IntegrationKey'], 'String');
      }
      if (data.hasOwnProperty('IntegrationHash')) {
        obj['IntegrationHash'] = ApiClient.convertToType(data['IntegrationHash'], 'String');
      }
      if (data.hasOwnProperty('IsTransferActive')) {
        obj['IsTransferActive'] = ApiClient.convertToType(data['IsTransferActive'], 'Boolean');
      }
      if (data.hasOwnProperty('LastAccountingDataFetchTimestamp')) {
        obj['LastAccountingDataFetchTimestamp'] = ApiClient.convertToType(data['LastAccountingDataFetchTimestamp'], 'Date');
      }
      if (data.hasOwnProperty('LastInvoicingDataFetchTimestamp')) {
        obj['LastInvoicingDataFetchTimestamp'] = ApiClient.convertToType(data['LastInvoicingDataFetchTimestamp'], 'Date');
      }
      if (data.hasOwnProperty('LastCustomerDataFetchTimestamp')) {
        obj['LastCustomerDataFetchTimestamp'] = ApiClient.convertToType(data['LastCustomerDataFetchTimestamp'], 'Date');
      }
      if (data.hasOwnProperty('LastProductDataFetchTimestamp')) {
        obj['LastProductDataFetchTimestamp'] = ApiClient.convertToType(data['LastProductDataFetchTimestamp'], 'Date');
      }
      if (data.hasOwnProperty('CustomersSyncOn')) {
        obj['CustomersSyncOn'] = ApiClient.convertToType(data['CustomersSyncOn'], 'Boolean');
      }
      if (data.hasOwnProperty('CustomersSyncDefaultHandleTypeID')) {
        obj['CustomersSyncDefaultHandleTypeID'] = ApiClient.convertToType(data['CustomersSyncDefaultHandleTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ProductsSyncOn')) {
        obj['ProductsSyncOn'] = ApiClient.convertToType(data['ProductsSyncOn'], 'Boolean');
      }
      if (data.hasOwnProperty('ProductsSyncDefaultHandleTypeID')) {
        obj['ProductsSyncDefaultHandleTypeID'] = ApiClient.convertToType(data['ProductsSyncDefaultHandleTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('LastOrderDataFetchTimestamp')) {
        obj['LastOrderDataFetchTimestamp'] = ApiClient.convertToType(data['LastOrderDataFetchTimestamp'], 'Date');
      }
      if (data.hasOwnProperty('LockPeriodID')) {
        obj['LockPeriodID'] = ApiClient.convertToType(data['LockPeriodID'], 'Integer');
      }
      if (data.hasOwnProperty('AutomaticUpdate')) {
        obj['AutomaticUpdate'] = ApiClient.convertToType(data['AutomaticUpdate'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} OrganisationIdentifier
   * @default ''
   */
  exports.prototype['OrganisationIdentifier'] = '';
  /**
   * @member {Integer} CreatedByUserID
   * @default 0
   */
  exports.prototype['CreatedByUserID'] = 0;
  /**
   * @member {Integer} CompanyLegalEntityID
   * @default 0
   */
  exports.prototype['CompanyLegalEntityID'] = 0;
  /**
   * @member {String} IntegrationKey
   * @default ''
   */
  exports.prototype['IntegrationKey'] = '';
  /**
   * @member {String} IntegrationHash
   * @default ''
   */
  exports.prototype['IntegrationHash'] = '';
  /**
   * @member {Boolean} IsTransferActive
   * @default false
   */
  exports.prototype['IsTransferActive'] = false;
  /**
   * @member {Date} LastAccountingDataFetchTimestamp
   */
  exports.prototype['LastAccountingDataFetchTimestamp'] = undefined;
  /**
   * @member {Date} LastInvoicingDataFetchTimestamp
   */
  exports.prototype['LastInvoicingDataFetchTimestamp'] = undefined;
  /**
   * @member {Date} LastCustomerDataFetchTimestamp
   */
  exports.prototype['LastCustomerDataFetchTimestamp'] = undefined;
  /**
   * @member {Date} LastProductDataFetchTimestamp
   */
  exports.prototype['LastProductDataFetchTimestamp'] = undefined;
  /**
   * @member {Boolean} CustomersSyncOn
   * @default false
   */
  exports.prototype['CustomersSyncOn'] = false;
  /**
   * @member {Integer} CustomersSyncDefaultHandleTypeID
   * @default 0
   */
  exports.prototype['CustomersSyncDefaultHandleTypeID'] = 0;
  /**
   * @member {Boolean} ProductsSyncOn
   * @default false
   */
  exports.prototype['ProductsSyncOn'] = false;
  /**
   * @member {Integer} ProductsSyncDefaultHandleTypeID
   * @default 0
   */
  exports.prototype['ProductsSyncDefaultHandleTypeID'] = 0;
  /**
   * @member {Date} LastOrderDataFetchTimestamp
   */
  exports.prototype['LastOrderDataFetchTimestamp'] = undefined;
  /**
   * @member {Integer} LockPeriodID
   * @default 0
   */
  exports.prototype['LockPeriodID'] = 0;
  /**
   * @member {Boolean} AutomaticUpdate
   * @default false
   */
  exports.prototype['AutomaticUpdate'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


